import React from 'react';

import { AsaphAvatar } from '@/components/shared/Avatar';
import { Chip, ChipList } from '@/components/shared/Chip';
import { S3Object } from 'models';

import styles from './VideoSynopsis.module.scss';

export interface VideoSynopsisProps {
	synopsisShown: boolean;
	authorName: string;
	authorRole: string;
	authorAvatar?: string;
	description?: string;
	mode?: 'light' | 'dark';
	tags?: string[];
}

export const VideoSynopsis = (props: VideoSynopsisProps) => {
	const {
		synopsisShown,
		authorName,
		authorRole,
		authorAvatar,
		description,
		mode = 'light',
		tags = [],
	} = props;

	const descriptionStyles = [
		styles['synopsis__desc'],
		styles[`synopsis__desc--${mode}`],
	];

	return (
		<div className={styles['synopsis']}>
			<div className={styles['synopsis__author']}>
				<AsaphAvatar
					size="x-small"
					name={authorName}
					// s3Image={authorAvatar}
					src={
						!authorAvatar
							? '/assets/icon/asaph-logo-icon.png'
							: authorAvatar
					}
				/>
				<div className={styles['synopsis__author-details']}>
					<div className={styles['synopsis__author-full-name']}>
						{authorName}
					</div>
					<div className={styles[`synopsis__role--${mode}`]}>
						{authorRole}
					</div>
				</div>
			</div>
			{synopsisShown && (
				<>
					<div className={descriptionStyles.join(' ')}>
						{description}
					</div>
					{tags.length > 0 && (
						<div className={styles['synopsis__chip-list']}>
							<ChipList>{tags.map(renderTag)}</ChipList>
						</div>
					)}
				</>
			)}
		</div>
	);
};

function renderTag(tag: string) {
	return (
		<Chip key={tag} color="light-gray">
			{tag}
		</Chip>
	);
}
